import { combineReducers } from 'redux';

import { reducer as connectReducer } from './Components/Connect/reducers';
import { reducer as filterTagReducer } from './Components/FilterTag/reducers';
import { extractFilterReducer } from './Components/Financial/reducers';
import { reducer as menuReducers } from './Components/Menu/reducers';
import { mySalesReducer } from './Components/MySales/reducers';
import { reducer as newProductWizardReducer } from './Components/NewProductWizard/reducers';
import { reducer as physicalDeliveryReducer } from './Components/PhysicalDelivery/reducers';
import { QuickViewReducer } from './Components/QuickView/reducers';
import { accessPolicyReducer } from './Orbita/AccessPolicy/reducer';
import { affiliateReducer } from './Orbita/Affiliate/reducer';
import { appsReducer } from './Orbita/Apps/reducer';
import { clickConversionReducer } from './Orbita/ClickConversion/reducer';
import { confirmationReducer } from './Orbita/Confirmation/reducer';
import { connectReducer as connectServiceReducer } from './Orbita/Connect/reducer';
import { currencyReducer } from './Orbita/Currency/reducer';
import { customerReducer } from './Orbita/Customer/reducer';
import { dashboardReducer } from './Orbita/Dashboard/reducer';
import { deliveryProviderReducer } from './Orbita/DeliveryProviders/reducer';
import { downloadReducer } from './Orbita/Download/reducer';
import { financialReducer } from './Orbita/Financial/reducer';
import { reducer as fiscalDocumentsReducer } from './Orbita/FiscalDocuments/reducers';
import { invoiceReducer } from './Orbita/Invoice/reducer';
import { messagingInternalReducer } from './Orbita/MessagingInternal/reducer';
import { myShoppingReducer } from './Orbita/MyShopping/reducer';
import { newzzReducer } from './Orbita/Newzz/reducer';
import { nutrorCourseReducer } from './Orbita/NutrorCourse/reducer';
import { orderReducer } from './Orbita/Orders/reducer';
import { productReducer } from './Orbita/Product/reducer';
import { profileReducer } from './Orbita/Profile/reducer';
import { questionReducer } from './Orbita/Questions/reducer';
import { saleReducer } from './Orbita/Sale/reducer';
import { showcaseReducer } from './Orbita/Showcase/reducer';
import { subscriptionReducer } from './Orbita/Subscriptions/reducer';
import { uploadReducer } from './Orbita/Upload/reducer';
import { userReducer } from './Orbita/User/reducer';
import { whitelistReducer } from './Orbita/Whitelist/reducer';

export const orbitaReducer = combineReducers({
  AccessPolicy: accessPolicyReducer,
  Affiliate: affiliateReducer,
  Apps: appsReducer,
  ClickConversion: clickConversionReducer,
  Connect: connectServiceReducer,
  Confirmation: confirmationReducer,
  Currency: currencyReducer,
  Customer: customerReducer,
  Dashboard: dashboardReducer,
  DeliveryProvider: deliveryProviderReducer,
  Download: downloadReducer,
  Financial: financialReducer,
  FiscalDocuments: fiscalDocumentsReducer,
  Invoice: invoiceReducer,
  Newzz: newzzReducer,
  NutrorCourse: nutrorCourseReducer,
  Product: productReducer,
  Profile: profileReducer,
  Questions: questionReducer,
  Sales: saleReducer,
  Subscriptions: subscriptionReducer,
  Upload: uploadReducer,
  User: userReducer,
  Whitelist: whitelistReducer,
  Messages: messagingInternalReducer,
  Orders: orderReducer,
  Showcase: showcaseReducer,
  MyShopping: myShoppingReducer,
});

export const componentsReducer = combineReducers({
  Connect: connectReducer,
  FilterTag: filterTagReducer,
  QuickView: QuickViewReducer,
  Menu: menuReducers,
  MySales: mySalesReducer,
  newProductWizard: newProductWizardReducer,
  physicalDelivery: physicalDeliveryReducer,
  ExtractFilter: extractFilterReducer,
});
